<template>
  
      
        <router-view></router-view>
 
</template>

<script>
import TopToolbar from '../../components/shared/topbar.vue';

export default {
    components:{
        TopToolbar
    },
    data: () => ({
        activeBtn:1
    }),
    methods:{
        create_acount(){

        },
        login(){
            this.$router.push({'name':'login'})
        }
    }
};
</script>
